const TEXT = {
    INVERLATIVE_BRAND_TEXT_1:"我邀请的",
    INVERLATIVE_BRAND_TEXT_2:"邀请我的",
    INVERLATIVE_BRAND_TEXT_3:"已拒绝",
    INVERLATIVE_BRAND_TEXT_4:"通过",
    INVERLATIVE_BRAND_TEXT_5:"拒绝",
    INVERLATIVE_BRAND_TEXT_6:"没有更多数据...",
    INVERLATIVE_BRAND_TEXT_7:"加载中...",
    INVERLATIVE_BRAND_TEXT_8:"确定执行",
    INVERLATIVE_BRAND_TEXT_9:"通过",
    INVERLATIVE_BRAND_TEXT_10:"拒绝",
    INVERLATIVE_BRAND_TEXT_11:"操作吗！",
    INVERLATIVE_BRAND_TEXT_12:"提示",
    INVERLATIVE_BRAND_TEXT_13:"我的上下級",
    INVERLATIVE_BRAND_TEXT_14:"性别：男",
    INVERLATIVE_BRAND_TEXT_15:"性别：女",
    INVERLATIVE_BRAND_TEXT_16:"微信号：",
    INVERLATIVE_BRAND_TEXT_17:"手机号：",
    INVERLATIVE_BRAND_TEXT_18:"地址：",
    INVERLATIVE_BRAND_TEXT_19:"通 过",
    INVERLATIVE_BRAND_TEXT_20:"拒 绝",
};
export {
	TEXT
}



// WEBPACK FOOTER //
// ./src/config/page/cn/invrelative/brand/index.js